<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { EyeIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const router = useRouter()
const now = ref(Date.now())
let timer

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now()
    const exp = authStore.impersonation?.expiresAt
    if (authStore.isImpersonating && exp && new Date(exp).getTime() <= now.value) {
      onExit()
    }
  }, 1000)
})
onUnmounted(() => clearInterval(timer))

const remaining = computed(() => {
  const exp = authStore.impersonation?.expiresAt
  if (!exp) return ''
  const ms = new Date(exp).getTime() - now.value
  if (ms <= 0) return 'expirada'
  const m = Math.floor(ms / 60000)
  const s = Math.floor((ms % 60000) / 1000)
  return `${m}:${String(s).padStart(2, '0')}`
})

async function onExit() {
  await authStore.exitImpersonation()
  router.replace('/login')
}
</script>

<template>
  <div
    v-if="authStore.isImpersonating"
    class="flex flex-wrap items-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-black dark:bg-amber-500"
  >
    <EyeIcon class="h-5 w-5 shrink-0" />
    <span class="min-w-0 flex-1">
      Vista de solo lectura — {{ authStore.impersonation?.ownerEmail || 'usuario' }}
      <template v-if="remaining"> · expira en {{ remaining }}</template>
    </span>
    <button
      class="shrink-0 rounded-lg bg-black/80 px-3 py-1 text-xs font-semibold text-white transition hover:bg-black"
      @click="onExit"
    >
      Salir
    </button>
  </div>
</template>
